import { connect, Dispatch } from 'react-redux';
import GeneralContent from './GeneralContent';
import { RootState } from '../../../../store/reducers/index';
import { GeneralActions, generalOptionSelect } from '../../../../store/action/generalActions';

const mapStateToProps = (state: RootState) => {
    return {

    };
};

const mapDispatchToProps = (dispatch: Dispatch<GeneralActions>) => {
    return {
        onChange(option: string, id: string) {
            dispatch(generalOptionSelect(option, id));
        }
    };
};

const GeneralContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(GeneralContent);

export default GeneralContainer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/general/GeneralContainer.tsx